import { render, staticRenderFns } from "./ModuleProductInfo.vue?vue&type=template&id=e0a8fb64&scoped=true&lang=html"
import script from "./ModuleProductInfo.vue?vue&type=script&lang=js"
export * from "./ModuleProductInfo.vue?vue&type=script&lang=js"
import style0 from "./ModuleProductInfo.vue?vue&type=style&index=0&id=e0a8fb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a8fb64",
  null
  
)

export default component.exports